import { useSuspenseQuery } from '@apollo/client';
import type { FC } from 'react';
import { Suspense, useEffect } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { CompaniesWorkflowStatusQueryDocument } from './companies-workflow-status.gql-types';
import { PageCreatedBanner } from './page-created-banner';
import { RepublishBanner } from './republish-banner';

export type CompanyBannersContainerProps = {
  companyId?: string | null;
  isDraft: boolean;
};
export const CompanyBannersContainerInner: FC<CompanyBannersContainerProps> = ({
  companyId,
  isDraft,
}) => {
  const { showCompanyBanner } = usePageContext();
  const { data } = useSuspenseQuery(
    CompaniesWorkflowStatusQueryDocument,
    companyId ? { variables: { id: companyId } } : { skip: true }
  );

  const showPageCreatedBanner = isDraft && data?.company?.inPublicationWorkflow;
  const showRepublishBanner = isDraft && !data?.company?.inPublicationWorkflow;

  useEffect(() => {
    if (showPageCreatedBanner || showRepublishBanner) {
      showCompanyBanner();
    }
  }, [data]);

  if (showPageCreatedBanner) {
    return <PageCreatedBanner />;
  }

  if (showRepublishBanner) {
    return <RepublishBanner />;
  }

  return null;
};

export const CompanyBannersContainer: FC<CompanyBannersContainerProps> = (
  props
) => {
  return (
    <Suspense fallback={null}>
      <CompanyBannersContainerInner {...props} />
    </Suspense>
  );
};
